import * as jotai from 'jotai'

import * as api from '@owl-nest/api-client/latest'
import type { ApiResponse } from '@owl-nest/api-client'
import * as hooks from '@owl-nest/hooks'

export async function getPartner(partnerId: number): Promise<ApiResponse<api.Partner>> {
  const response = await api.api.get.partner({
    urlParams: { partnerId: String(partnerId) },
  })

  return response.next((success) => success.body)
}

const PARTNERS_CACHE = jotai.atom<hooks.Cache<api.Partner>>({})

export function usePartner(partnerId?: number) {
  const {
    cache,
    query: queryPartner,
    mutate: mutatePartner,
  } = hooks.useSharedQuery(getPartner, {
    atom: PARTNERS_CACHE,
    id,
  })

  return { response: getResponse(), query, mutate }

  async function query(): Promise<void> {
    if (partnerId) {
      return queryPartner(partnerId)
    }
  }

  function mutate(partner: api.Partner): void {
    if (partnerId) {
      return mutatePartner([partnerId], { data: partner, status: hooks.QueryStatus.SUCCESS })
    }
  }

  function id(partnerId: number): string {
    return String(partnerId)
  }

  function getResponse(): hooks.Response<api.Partner> {
    if (partnerId === undefined) {
      return { status: hooks.QueryStatus.PRISTINE }
    }

    const response = cache[id(partnerId)]

    if (response === undefined) {
      return { status: hooks.QueryStatus.PRISTINE }
    }

    return response
  }
}
